import * as z from "zod";

export const EmploymentTypeEnum = z.enum([
  "full_time",
  "part_time",
  "contract",
  "temporary",
  "internship",
]);

export const JobSchema = z.object({
  id: z.string().uuid(),
  title: z
    .string()
    .min(1, "Title is required")
    .max(255, "Title must be less than 255 characters"),
  description: z
    .string()
    .max(1000, "Description must be less than 1000 characters")
    .nullable(),
  employment_type: EmploymentTypeEnum.default("full_time"),
  department_id: z.string().uuid().nullable().optional(),
  reports_to: z.string().uuid().nullable().optional(),
  task_id: z.string().uuid().nullable().optional(),
  assigned_employee_id: z.string().uuid().nullable().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createJobSchema = JobSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateJobSchema = JobSchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
